"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _useModal2 = _interopRequireDefault(require("../../../hooks/useModal/useModal"));
var _Header = _interopRequireDefault(require("../../../components/Modals/Header.styled"));
var _Modal = require("../../../constants/Modal");
var _UploadErrorForm = require("./UploadErrorForm.styled");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _truncate = require("../../../utils/actionUtils/truncate");
function UploadErrorForm(_ref) {
  var _initialValue$files;
  var clearModal = _ref.clearModal;
  var MAX_LENGTH = 40;
  var _useModal = (0, _useModal2["default"])(_Modal.UPLOAD_ERROR_FORM, clearModal),
    isOpen = _useModal.isOpen,
    clear = _useModal.clear,
    _useModal$initialValu = _useModal.initialValue,
    initialValue = _useModal$initialValu === void 0 ? {} : _useModal$initialValu;
  return /*#__PURE__*/_react["default"].createElement(_UploadErrorForm.CustomModal, {
    isOpen: isOpen,
    toggle: clear
  }, /*#__PURE__*/_react["default"].createElement(_Header["default"], {
    "data-testid": "title"
  }, initialValue.title), /*#__PURE__*/_react["default"].createElement(_UploadErrorForm.StyledModalBody, null, /*#__PURE__*/_react["default"].createElement("p", null, initialValue.description), /*#__PURE__*/_react["default"].createElement(_UploadErrorForm.UploadErrors, null, (_initialValue$files = initialValue.files) === null || _initialValue$files === void 0 ? void 0 : _initialValue$files.map(function (file, index) {
    var _file$errors, _file$errors2;
    return /*#__PURE__*/_react["default"].createElement(_UploadErrorForm.ErrorStyle, {
      key: index
    }, file.name ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_UploadErrorForm.Space, null, ' ', /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _freeSolidSvgIcons.faFileVideo,
      color: "grey"
    }), ' '), "".concat((0, _truncate.truncate)(file.name, MAX_LENGTH)), " ", '(' + file.size + ')', (_file$errors = file.errors) === null || _file$errors === void 0 ? void 0 : _file$errors.map(function (error, index) {
      return /*#__PURE__*/_react["default"].createElement(_UploadErrorForm.FileErrors, {
        key: index
      }, error);
    })) : /*#__PURE__*/_react["default"].createElement("div", null, file === null || file === void 0 || (_file$errors2 = file.errors) === null || _file$errors2 === void 0 ? void 0 : _file$errors2.map(function (error, index) {
      return /*#__PURE__*/_react["default"].createElement(_UploadErrorForm.MultipleFilesError, {
        key: index
      }, /*#__PURE__*/_react["default"].createElement(_UploadErrorForm.Space, null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _freeSolidSvgIcons.faExclamationTriangle,
        color: "red"
      })), error);
    })));
  })), /*#__PURE__*/_react["default"].createElement(_UploadErrorForm.StyledDoneButton, {
    "data-testid": "Done",
    color: "white",
    onClick: clear
  }, "Done")));
}
var _default = exports["default"] = UploadErrorForm;